import { TransProps, useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import { postalCodeRegexp } from '../../../constants';
import { AddressFormData } from '../../../interfaces';

export const useSmallLocationFormValidation: () => Yup.SchemaOf<AddressFormData> = (): Yup.SchemaOf<AddressFormData> => {
  const { t }: TransProps<never> = useTranslation();

  return Yup.object().shape({
    street: Yup.string()
      .max(128, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    houseNumber: Yup.string()
      .max(8, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    apartmentNumber: Yup.string()
      .max(8, t('onarte.common.validations.maxLength'))
      .optional()
      .nullable(),
    postalCode: Yup.string()
      .required(t('onarte.common.requiredField'))
      .matches(postalCodeRegexp, t('onarte.common.validations.postalCode')),
    city: Yup.string()
      .max(128, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    country: Yup.string()
      .max(64, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
  });
};
